import { render, staticRenderFns } from "./GridColaborador.vue?vue&type=template&id=402f39fa&scoped=true"
import script from "./GridColaborador.vue?vue&type=script&lang=js"
export * from "./GridColaborador.vue?vue&type=script&lang=js"
import style0 from "./GridColaborador.vue?vue&type=style&index=0&id=402f39fa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402f39fa",
  null
  
)

export default component.exports